export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14940.0db11ce8.jpg";